/* Layout types and other constants */

export enum LayoutType {
  LAYOUT_VERTICAL = "vertical",
  LAYOUT_HORIZONTAL = "horizontal",
}

export enum LayoutTheme {
  THEME_LIGHT = "light",
  THEME_DARK = "dark",
}

export enum LayoutWidth {
  LAYOUT_WIDTH_FLUID = "fluid",
  LAYOUT_WIDTH_BOXED = "boxed",
  LAYOUT_WIDTH_DETACHED = "detached",
}

export enum TopBarTheme {
  TOPBAR_LIGHT = "light",
  TOPBAR_DARK = "dark",
  TOPBAR_BRAND = "brand",
}

export enum SideBarTheme {
  LEFT_SIDEBAR_THEME_LIGHT = "light",
  LEFT_SIDEBAR_THEME_DARK = "dark",
  LEFT_SIDEBAR_THEME_BRAND = "brand",
}

export enum SideBarType {
  LEFT_SIDEBAR_TYPE_DEFAULT = "default",
  LEFT_SIDEBAR_TYPE_COMPACT = "compact",
  LEFT_SIDEBAR_TYPE_CONDENSED = "condensed",
  LEFT_SIDEBAR_TYPE_HOVER = "sm-hover",
  LEFT_SIDEBAR_TYPE_FULL = "full",
  LEFT_SIDEBAR_TYPE_FULLSCREEN = "fullscreen",
}

export enum LayoutPosition {
  POSITION_FIXED = "fixed",
  POSITION_SCROLLABLE = "scrollable",
}
